"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.tapeBuilderGraphToArtifactsDocument = exports.artifactsDocumentToTapeBuilderGraph = exports.xlsx = exports.progress = exports.DbInstanceUtils = exports.DbGraphUtils = exports.AssetExtractor = exports.BbplGraph = exports.createLpCfSlugGroupings = exports.detachSyntheticRecords = exports.attachSyntheticRecords = exports.validateDataTapes = exports.getLpCfGroupings = exports.createLpToCfMap = exports.consts = exports.convertor = exports.dbNodes = exports.typeguards = exports.createLoanProductShell = exports.generateXlsx2CsvConfig = exports.createTapeBuilderFromArtifactsDocument = exports.createTapeInstanceBuilder = exports.isSameGraph = exports.interpolatePrompt = exports.TapeBuilderUI = exports.TapeNodes = exports.OperationNodes = void 0;
const consts = __importStar(require("./consts"));
exports.consts = consts;
const convertor_1 = require("./convertor");
Object.defineProperty(exports, "convertor", { enumerable: true, get: function () { return convertor_1.convertor; } });
const tapeBuilder_1 = require("./tapeBuilder");
const uinodeTypes_1 = require("./uiNodes/uinodeTypes");
Object.defineProperty(exports, "OperationNodes", { enumerable: true, get: function () { return uinodeTypes_1.OperationNodes; } });
Object.defineProperty(exports, "TapeNodes", { enumerable: true, get: function () { return uinodeTypes_1.TapeNodes; } });
exports.TapeBuilderUI = __importStar(require("./uiNodes/uiNodes"));
var interpolatePrompt_1 = require("./uiNodes/operations/ai2csv/interpolatePrompt");
Object.defineProperty(exports, "interpolatePrompt", { enumerable: true, get: function () { return interpolatePrompt_1.interpolatePrompt; } });
var sameGraph_1 = require("./sameGraph");
Object.defineProperty(exports, "isSameGraph", { enumerable: true, get: function () { return sameGraph_1.isSameGraph; } });
var tapeBuilder_2 = require("./tapeBuilder");
Object.defineProperty(exports, "createTapeInstanceBuilder", { enumerable: true, get: function () { return tapeBuilder_2.createTapeBuilder; } });
Object.defineProperty(exports, "createTapeBuilderFromArtifactsDocument", { enumerable: true, get: function () { return tapeBuilder_2.createTapeBuilderFromArtifactsDocument; } });
var generateXlsx2CsvConfig_1 = require("./generateXlsx2CsvConfig");
Object.defineProperty(exports, "generateXlsx2CsvConfig", { enumerable: true, get: function () { return generateXlsx2CsvConfig_1.generateXlsx2CsvConfig; } });
var createLoanProductShell_1 = require("./createLoanProductShell");
Object.defineProperty(exports, "createLoanProductShell", { enumerable: true, get: function () { return createLoanProductShell_1.createLoanProductShell; } });
exports.typeguards = __importStar(require("./typeguards"));
exports.dbNodes = __importStar(require("./dbNodes/dbNodes"));
var mesh_1 = require("./mesh");
Object.defineProperty(exports, "createLpToCfMap", { enumerable: true, get: function () { return mesh_1.createLpToCfMap; } });
Object.defineProperty(exports, "getLpCfGroupings", { enumerable: true, get: function () { return mesh_1.getLpCfGroupings; } });
var validation_1 = require("./validation");
Object.defineProperty(exports, "validateDataTapes", { enumerable: true, get: function () { return validation_1.validateDataTapes; } });
var synthetic_1 = require("./synthetic");
Object.defineProperty(exports, "attachSyntheticRecords", { enumerable: true, get: function () { return synthetic_1.attachSyntheticRecords; } });
Object.defineProperty(exports, "detachSyntheticRecords", { enumerable: true, get: function () { return synthetic_1.detachSyntheticRecords; } });
Object.defineProperty(exports, "createLpCfSlugGroupings", { enumerable: true, get: function () { return synthetic_1.createLpCfSlugGroupings; } });
var bbplGraph_1 = require("./bbplGraph");
Object.defineProperty(exports, "BbplGraph", { enumerable: true, get: function () { return bbplGraph_1.BbplGraph; } });
var tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
Object.defineProperty(exports, "AssetExtractor", { enumerable: true, get: function () { return tape_sanitizer_1.AssetExtractor; } });
exports.DbGraphUtils = __importStar(require("./graphUtils/dbGraphUtils"));
exports.DbInstanceUtils = __importStar(require("./graphUtils/dbInstanceUtils"));
exports.progress = __importStar(require("./bbplGraph/progress"));
exports.xlsx = __importStar(require("./bbplGraph/xlsx"));
const artifactsDocumentToTapeBuilderGraph = ({ artifactsDocument, }) => {
    return convertor_1.convertor.artifactsDocumentToTapeBuilder({
        artifactsDocument,
    });
};
exports.artifactsDocumentToTapeBuilderGraph = artifactsDocumentToTapeBuilderGraph;
// TapeBuilderNodes => ArtifactsDocument conversion requires
// an instance of tapeBuilderRuntime to validate the operation configurations
// we need to pass a callback to create such instance to break circular dependency.
const tapeBuilderGraphToArtifactsDocument = ({ graph, creditFacilities, loanProducts, artifactDocumentId, }) => {
    return convertor_1.convertor.tapeBuilderToArtifactsDocument({
        artifactDocumentId,
        graph,
        creditFacilities,
        loanProducts,
        createTapeBuilder: tapeBuilder_1.createTapeBuilder,
    });
};
exports.tapeBuilderGraphToArtifactsDocument = tapeBuilderGraphToArtifactsDocument;
//# sourceMappingURL=index.js.map